import { connect } from 'react-redux'

import NavigationHelper from 'layers/navigation/navigationHelper'
import withApiError from 'layers/errorHandling/apiError'

import Component from './component'
import { FlaggedRouteContentGetter as RouteContentGetter } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'
import { resolveRouteServiceApp } from 'utils/productHelpers'

const navigationConnect = connect(
  NavigationHelper.mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

const FamilyResourcesContainer = RouteContentGetter(
  withApiError(navigationConnect(Component)),
  options,
)

export default FamilyResourcesContainer
